<div mat-dialog-title>
  <app-dialog-close-cross></app-dialog-close-cross>
  <h2>{{ 'REWORK_RECIPES.MODAL.TITLE' | translate }}</h2>
</div>

<div mat-dialog-content>
  <mat-label>
    {{ 'REWORK_RECIPES.MODAL.WARNING' | translate }}
  </mat-label>
</div>

<div mat-dialog-actions class="rework-recipe-action-buttons">
  <button class="space-h-s btn-warn" mat-raised-button (click)="cancel()">{{ 'CANCEL' | translate }}</button>
  <button class="space-h-s btn-submit" mat-raised-button (click)="submit()">{{ 'REWORK_RECIPES.MODAL.BTN_REWORK' | translate }}</button>
</div>
